// LIST
export const FETCH_APPOINTMENTS = "app/APPOINTMENTS/FETCH_APPOINTMENTS";
export const FETCH_APPOINTMENTS_SUCCESS =
  "app/APPOINTMENTS/FETCH_APPOINTMENTS_SUCCESS";
export const FETCH_APPOINTMENTS_FAILURE =
  "app/APPOINTMENTS/FETCH_APPOINTMENTS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/APPOINTMENTS/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/APPOINTMENTS/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/APPOINTMENTS/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_APPOINTMENT = "app/APPOINTMENTS/ADD_APPOINTMENT";
export const ADD_APPOINTMENT_SUCCESS =
  "app/APPOINTMENTS/ADD_APPOINTMENT_SUCCESS";
export const ADD_APPOINTMENT_FAILURE =
  "app/APPOINTMENTS/ADD_APPOINTMENT_FAILURE";

// EDIT
export const EDIT_APPOINTMENT = "app/APPOINTMENTS/EDIT_APPOINTMENT";
export const EDIT_APPOINTMENT_SUCCESS =
  "app/APPOINTMENTS/EDIT_APPOINTMENT_SUCCESS";
export const EDIT_APPOINTMENT_FAILURE =
  "app/APPOINTMENTS/EDIT_APPOINTMENT_FAILURE";

// DELETE
export const DELETE_APPOINTMENT = "app/APPOINTMENTS/DELETE_APPOINTMENT";
export const DELETE_APPOINTMENT_SUCCESS =
  "app/APPOINTMENTS/DELETE_APPOINTMENT_SUCCESS";
export const DELETE_APPOINTMENT_FAILURE =
  "app/APPOINTMENTS/DELETE_APPOINTMENT_FAILURE";
